import { createAction, props } from '@ngrx/store';

export const displayGlobalError = createAction('[Error] Display Global Error', props<{ error: Error | string }>());
